export const ScrollDownSvg = ({height,width}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "28"}
    height={height || "28"}
    viewBox="0 0 58 58"
    fill="none"
  >
    <g filter="url(#filter0_b_3670_12969)">
      <circle
        cx="29"
        cy="29"
        r="29"
        fill="rgb(225, 225, 225)"
        fillOpacity="0.25"
      ></circle>
      <circle cx="29" cy="29" r="28" stroke="rgb(176, 176, 176)" stroke-width="2"></circle>
    </g>
    <path
      d="M29.75 21C29.75 20.5858 29.4142 20.25 29 20.25C28.5858 20.25 28.25 20.5858 28.25 21L29.75 21ZM28.4697 37.5303C28.7626 37.8232 29.2374 37.8232 29.5303 37.5303L34.3033 32.7574C34.5962 32.4645 34.5962 31.9896 34.3033 31.6967C34.0104 31.4038 33.5355 31.4038 33.2426 31.6967L29 35.9393L24.7574 31.6967C24.4645 31.4038 23.9896 31.4038 23.6967 31.6967C23.4038 31.9896 23.4038 32.4645 23.6967 32.7574L28.4697 37.5303ZM28.25 21L28.25 37L29.75 37L29.75 21L28.25 21Z"
      fill="rgb(118, 118, 118)"
    ></path>
    <defs>
      <filter
        id="filter0_b_3670_12969"
        x="-70"
        y="-70"
        width="198"
        height="198"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feGaussianBlur
          in="BackgroundImageFix"
          stdDeviation="35"
        ></feGaussianBlur>
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_3670_12969"
        ></feComposite>
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_3670_12969"
          result="shape"
        ></feBlend>
      </filter>
    </defs>
  </svg>
)
